import { memo, useEffect, useMemo, useState } from 'react';
import FeatureCarousel from '../FeatureBlockElements/FeatureCarousel/FeatureCarousel';
import OverlapCarouselBlock from '../FeatureBlocks/OverlapCarouselBlock/OverlapCarouselBlock';
import PromoBlockLeft from '../FeatureBlocks/PromoBlockLeft/PromoBlockLeft';
import { useTranslation } from 'react-i18next';
import TestimonialCarouselCardBlock from '../FeatureBlocks/TestimonialCarouselCardBlock/TestimonialCarouselCardBlock';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { useNewBranding } from '../../hooks/useNewBranding';
import { featuredItems } from '../../data/featuredItems';
import FeaturedIn from '../FeaturedIn/FeaturedIn';
import BroadIntentTraditionalHero from './BroadIntentTraditionalHero';
import BroadIntentChatHero from './BroadIntentChatHero';

import './broad-intent.scss';

const BroadIntentContent = ({
    variant,
    path,
    promoCode
}: {
    variant: 'broad_intent_1_chat' | 'broad_intent_2_traditional';
    path: string;
    promoCode: string;
}) => {
    const { t } = useTranslation();
    const breakpoints = useBreakpoint();

    const { isNewBranding } = useNewBranding({ path });
    const [hasMounted, setHasMounted] = useState(false);

    const promoBlockLeftProps = useMemo(() => {
        const ctaText = breakpoints.mediumUp
            ? t('broadIntentContent.promoBlockLeft.ctaText')
            : t('broadIntentContent.promoBlockLeft.ctaTextMobile');
        return {
            title: t('broadIntentContent.promoBlockLeft.title'),
            ctaText,
            source: 'promo block left - dark',
            promoCode,
            buttonStyle: 'primary--bright',
            customClass: 'promo-block-left--new-branding'
        };
    }, [breakpoints, t]);

    const isChatVariant = variant === 'broad_intent_1_chat';

    useEffect(() => {
        setHasMounted(true);
    }, []);

    if (!hasMounted) {
        return null; // Avoid SSR mismatch
    }

    return (
        <div
            className={`broad-intent-content${
                isNewBranding ? ' new-branding' : ''
            }`}
        >
            <>
                {isChatVariant ? (
                    <BroadIntentChatHero />
                ) : (
                    <BroadIntentTraditionalHero />
                )}
            </>
            <FeaturedIn
                featuredItems={featuredItems}
                size="small"
                showTitle={isChatVariant}
                isNewBranding={isNewBranding}
                staticMode={true}
            />
            <FeatureCarousel useNewBranding={isNewBranding} />
            <OverlapCarouselBlock
                useNewBranding={isNewBranding}
                registrationCTAText={t(
                    'broadIntentContent.registrationCTAText'
                )}
            />
            <TestimonialCarouselCardBlock
                useNewBranding={isNewBranding}
                customTitleTransId="broadIntentContent.testimonialCardsBlock.title"
            />
            <PromoBlockLeft {...promoBlockLeftProps} />
        </div>
    );
};

export default memo(BroadIntentContent);
